<template>
  <div>
    <div class="modal-mask" transition="modal">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">Категория</slot>
          </div>

          <div class="modal-body">
            <div class="form-group">
              <label>Название организации</label>
              <input
                disabled
                :value="suggestion.orgName"
                type="text"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>ФИО</label>
              <input
                disabled
                :value="suggestion.fio"
                type="text"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>Название класса</label>
              <textarea
                disabled
                :value="suggestion.productName"
                type="text"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>Предлагаемая единица измерения</label>
              <input
                disabled
                :value="suggestion.unitSuggestion"
                type="text"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>Тип класса</label>
              <input
                disabled
                :value="suggestion.product_type"
                type="text"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>Комментарий к предложению</label>
              <textarea
                disabled
                :value="suggestion.comment"
                type="text"
                class="form-control"
              />
            </div>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button
                class="modal-button btn btn-danger"
                @click="$emit('closeModal', false)"
              >
                Закрыть
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["suggestion"],
};
</script>
<style lang=""></style>